"use client";
import Image from "next/image";

export default function Footer() {
  return (
    <footer className="footer h-30" style={{ height: 80 }}>
      <div className="footer-content">
        {/* <div className="footer-links "> */}
        <div
          className="flex flex-row items-center gap-4 text-left, text-[11px]"
          style={{ animationDelay: "0.1s", height: 50 }}
        >
          <a
            href="/politica-de-privacidade"
            aria-label="Política de Privacidade"
          >
            Política de Privacidade
          </a>
          <span>|</span>
          <a href="/termos-de-uso" aria-label="Termos de uso">
            Termos de Uso
          </a>
          <span>|</span>
          <a href="mailto:faleconosco@casacazetv.com.br" aria-label="Contato">
            Contato
          </a>
        </div>

        <div
          className="footer-logos cursor-pointer reveal-up"
          style={{ animationDelay: "0.2s", display: "none" }}
          onClick={() => window.open("https://tm1.com.br/pt/")}
        >
          <Image
            src="/images/tm1-caze.svg"
            alt="Logo 1"
            width={160}
            height={40}
          />
        </div>
      </div>
      <style jsx>{`
        .header {
          background: var(--brand-blue);
          padding: 1rem 2rem;
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .header-container {
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .nav {
          display: flex;
          gap: 2rem;
        }

        .nav a {
          color: white;
          text-decoration: none;
          font-size: 0.9rem;
          transition: opacity 0.3s;
        }

        .nav a:hover {
          opacity: 0.8;
        }

        .btn-ingressos {
          background: var(--brand-yellow);
          color: #000;
          padding: 0.75rem 2rem;
          border-radius: 25px;
          text-decoration: none;
          font-weight: bold;
          transition: transform 0.3s;
        }

        .btn-ingressos:hover {
          transform: scale(1.05);
        }

        .hero {
          background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
          padding: 4rem 2rem;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          align-items: center;
          min-height: 600px;
          position: relative;
          overflow: hidden;
        }

        .hero-content {
          max-width: 600px;
          color: white;
        }

        .hero-title {
          font-size: 4rem;
          font-weight: bold;
          line-height: 1;
          margin-bottom: 1.5rem;
          color: white;
        }

        .hero-description {
          font-size: 1rem;
          line-height: 1.6;
          margin-bottom: 2rem;
          color: #ddd;
        }

        .btn-comprar {
          background: var(--brand-yellow);
          color: #000;
          padding: 1rem 2.5rem;
          border: none;
          border-radius: 30px;
          font-weight: bold;
          font-size: 1rem;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          transition: transform 0.3s;
        }

        .btn-comprar:hover {
          transform: scale(1.05);
        }

        .hero-logos {
          display: flex;
          gap: 2rem;
          margin-top: 2rem;
          color: white;
          font-size: 1.5rem;
        }

        .hero-image {
          position: relative;
        }

        .building-image {
          width: 100%;
          height: auto;
          border-radius: 20px;
          box-shadow: 0 20px 60px rgba(0, 255, 136, 0.3);
        }

        .features {
          background: var(--brand-blue);
          padding: 4rem 2rem;
          position: relative;
          overflow: hidden;
        }

        .feature-player {
          text-align: center;
          margin-bottom: 2rem;
        }

        .player-image {
          max-height: 400px;
          width: auto;
          filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.3));
        }

        .feature-cards {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 2rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        .feature-card {
          aspect-ratio: 1;
          border-radius: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          transition: transform 0.3s;
          cursor: pointer;
        }

        .feature-card:hover {
          transform: translateY(-10px);
        }

        .feature-card.green {
          background: var(--brand-green);
        }

        .feature-card.pink {
          background: var(--brand-pink);
        }

        .feature-card.cyan {
          background: var(--brand-cyan);
        }

        .feature-card.yellow {
          background: var(--brand-yellow);
        }

        .feature-text {
          color: white;
          font-size: 1.5rem;
          font-weight: bold;
          text-align: center;
          line-height: 1.2;
        }

        .star-left,
        .star-right {
          position: absolute;
          width: 100px;
          height: 100px;
          background: var(--brand-yellow);
          clip-path: polygon(
            50% 0%,
            61% 35%,
            98% 35%,
            68% 57%,
            79% 91%,
            50% 70%,
            21% 91%,
            32% 57%,
            2% 35%,
            39% 35%
          );
        }

        .star-left {
          left: 5%;
          top: 50%;
        }

        .star-right {
          right: 5%;
          top: 20%;
        }

        .tickets {
          background: var(--brand-blue);
          padding: 4rem 2rem;
          position: relative;
        }

        .tickets-title {
          background: var(--brand-yellow);
          color: #000;
          font-size: 2rem;
          font-weight: bold;
          padding: 1rem 2rem;
          display: inline-block;
          margin: 0 auto 1rem;
          display: block;
          width: fit-content;
        }

        .tickets-subtitle {
          color: white;
          text-align: center;
          margin-bottom: 3rem;
          line-height: 1.8;
        }

        .tickets-container {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 3rem;
          max-width: 1000px;
          margin: 0 auto;
        }

        .ticket-card {
          background: white;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
        }

        .ticket-header {
          padding: 1.5rem;
          color: white;
          text-align: center;
          font-size: 0.9rem;
          font-weight: bold;
        }

        .ticket-header.red {
          background: var(--brand-red);
        }

        .ticket-price {
          display: block;
          font-size: 1.5rem;
          margin: 0.5rem 0;
        }

        .ticket-content {
          padding: 2rem;
        }

        .ticket-content.cyan-bg {
          background: linear-gradient(180deg, #00bcd4 0%, #0097a7 100%);
          color: white;
        }

        .ticket-type {
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 1rem;
        }

        .ticket-description {
          margin-bottom: 1.5rem;
          font-size: 0.95rem;
        }

        .ticket-badge {
          background: var(--brand-red);
          color: white;
          padding: 0.75rem;
          border-radius: 10px;
          text-align: center;
          font-weight: bold;
          margin-bottom: 1.5rem;
          font-size: 0.85rem;
        }

        .ticket-features {
          list-style: none;
          margin-bottom: 2rem;
        }

        .ticket-features li {
          padding: 0.5rem 0;
          padding-left: 1.5rem;
          position: relative;
        }

        .ticket-features li:before {
          content: "✓";
          position: absolute;
          left: 0;
          font-weight: bold;
        }

        .btn-comprar-ticket {
          width: 100%;
          padding: 1rem;
          border: none;
          border-radius: 30px;
          font-weight: bold;
          font-size: 1rem;
          cursor: pointer;
          transition: transform 0.3s;
        }

        .btn-comprar-ticket.yellow {
          background: var(--brand-yellow);
          color: #000;
        }

        .btn-comprar-ticket:hover {
          transform: scale(1.05);
        }

        .tickets-badge {
          text-align: center;
          margin-top: 3rem;
        }

        .badge-text {
          background: white;
          color: var(--brand-blue);
          padding: 1rem 2rem;
          border-radius: 50px;
          font-weight: bold;
          display: inline-block;
        }

        .carousel-section {
          background: var(--brand-blue);
          padding: 4rem 2rem;
          position: relative;
        }

        .carousel-title {
          background: var(--brand-yellow);
          color: #000;
          font-size: 2rem;
          font-weight: bold;
          padding: 1rem 2rem;
          display: inline-block;
          text-align: center;
          width: 100%;
        }

        .carousel-subtitle {
          color: white;
          text-align: center;
          font-size: 1.5rem;
          margin-bottom: 3rem;
        }

        .carousel {
          max-width: 1000px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          gap: 2rem;
        }

        .carousel-btn {
          background: white;
          border: none;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          font-size: 2rem;
          cursor: pointer;
          transition: transform 0.3s;
          flex-shrink: 0;
        }

        .carousel-btn:hover {
          transform: scale(1.1);
        }

        .carousel-content {
          background: white;
          border-radius: 20px;
          padding: 2rem;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2rem;
          align-items: center;
        }

        .slide-image {
          width: 100%;
          height: auto;
          border-radius: 10px;
        }

        .carousel-item-title {
          color: var(--brand-green);
          font-size: 1.8rem;
          font-weight: bold;
          margin-bottom: 1rem;
        }

        .carousel-item-description {
          margin-bottom: 1rem;
          line-height: 1.6;
        }

        .carousel-item-highlight {
          font-style: italic;
          color: #666;
        }

        .carousel-logo {
          text-align: right;
          margin-top: 2rem;
          color: var(--brand-yellow);
          font-weight: bold;
          font-size: 2rem;
          line-height: 1.2;
        }

        .partner-section {
          background: var(--brand-yellow);
          padding: 4rem 2rem;
        }

        .partner-title {
          text-align: center;
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 2rem;
        }

        .pink-text {
          color: var(--brand-pink);
        }

        .partner-description,
        .partner-cta {
          text-align: center;
          max-width: 800px;
          margin: 0 auto 2rem;
          line-height: 1.8;
        }

        .partner-form {
          max-width: 600px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .form-input {
          padding: 1rem;
          border: none;
          border-radius: 10px;
          font-size: 1rem;
          background: white;
        }

        .form-note {
          font-size: 0.85rem;
          text-align: center;
          font-style: italic;
        }

        .btn-enviar {
          background: var(--brand-blue);
          color: white;
          padding: 1rem 3rem;
          border: none;
          border-radius: 30px;
          font-weight: bold;
          font-size: 1rem;
          cursor: pointer;
          align-self: center;
          transition: transform 0.3s;
        }

        .btn-enviar:hover {
          transform: scale(1.05);
        }

        .partner-contact {
          text-align: center;
          margin-top: 2rem;
        }

        .partner-contact a {
          color: #000;
          font-weight: bold;
        }

        .corporate-section {
          background: var(--brand-green);
          padding: 4rem 2rem;
          position: relative;
        }

        .corporate-title {
          background: white;
          color: var(--brand-blue);
          font-size: 2rem;
          font-weight: bold;
          padding: 1rem 2rem;
          display: inline-block;
          text-align: center;
          width: 100%;
          margin-bottom: 1rem;
        }

        .corporate-subtitle {
          color: white;
          text-align: center;
          margin-bottom: 3rem;
          font-size: 1.1rem;
        }

        .corporate-benefits {
          max-width: 800px;
          margin: 0 auto 3rem;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .benefit-item {
          padding: 1.5rem;
          border-radius: 50px;
          color: white;
          font-weight: bold;
        }

        .benefit-item.pink {
          background: var(--brand-pink);
        }

        .btn-fale-conosco {
          background: white;
          color: var(--brand-green);
          padding: 1rem 3rem;
          border: none;
          border-radius: 30px;
          font-weight: bold;
          font-size: 1rem;
          cursor: pointer;
          display: block;
          margin: 0 auto;
          transition: transform 0.3s;
        }

        .btn-fale-conosco:hover {
          transform: scale(1.05);
        }

        .corporate-badge {
          text-align: right;
          margin-top: 2rem;
          color: white;
          font-weight: bold;
          font-size: 1.5rem;
        }

        .footer {
          background: var(--brand-blue);
          padding: 1rem 2rem;
          color: white;
        }

        .footer-title {
          text-align: center;
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 2rem;
          color: var(--brand-yellow);
        }

        .footer-content {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          gap: 2rem;
        }

        .footer-links {
          display: flex;
          gap: 10px;
          align-items: center;
        }

        .footer-links a {
          color: white;
          text-decoration: none;
          font-size: 0.9rem;
        }

        .footer-logos {
          display: flex;
          gap: 1rem;
          align-items: center;
        }

        .footer-social {
          display: flex;
          gap: 1rem;
        }

        .social-link {
          width: 40px;
          height: 40px;
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          transition: transform 0.3s;
        }

        .social-link:hover {
          transform: scale(1.1);
        }

        @media (max-width: 768px) {
          .header-container {
            flex-direction: column;
            gap: 1rem;
          }

          .nav {
            flex-direction: column;
            gap: 0.5rem;
            text-align: center;
          }

          .hero {
            grid-template-columns: 1fr;
            padding: 2rem 1rem;
          }

          .hero-title {
            font-size: 2.5rem;
          }

          .feature-cards {
            grid-template-columns: repeat(2, 1fr);
          }

          .tickets-container {
            grid-template-columns: 1fr;
          }

          .carousel-content {
            grid-template-columns: 1fr;
          }

          .footer-content {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>
    </footer>
  );
}
